import React from 'react';
import NoCoins from './NoCoins';
import HasCoins from './HasCoins';
import { ApplicationState } from '../../../store';
import { useSelector } from 'react-redux';
import { Skeleton, Dialog } from '@gerdau/hefesto';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../routes';
import { ELoyaltyRoutes } from '../loyalty.routes';

const LoyaltyCoins: React.FC = () => {
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const showNoCoinsPage = loyalty.rewards.total.total_coins == 0;
  const history = useHistory();
  return (
    <div>
      {loyalty.rewards.loading && <Skeleton />}
      {!loyalty.rewards.loading && loyalty.rewards.error && (
        <div>
          <Skeleton />
          <Dialog
            dialogSize="sm"
            textContent={'Desculpe, ocorreu um problema ao buscar seus pontos.'}
            actions={{
              right: {
                name: 'back',
                children: 'Ok',
                onClick: () => {
                  history.push(
                    `${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_HOW_WORKS}`
                  );
                }
              }
            }}
          />
        </div>
      )}
      {!loyalty.rewards.loading && !loyalty.rewards.error && (
        <>{showNoCoinsPage ? <NoCoins /> : <HasCoins />}</>
      )}
    </div>
  );
};

export default LoyaltyCoins;
